import { getBaseUrl } from '../utils/getBaseUrl';

const baseURL = getBaseUrl() + 'user/';

export const GetAllUser = async () => {
    try {
        const response = await fetch(baseURL + 'getall', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching users:', error);
    }
};

export const CheckLogin = async (recordBody) => {
    try {
        const response = await fetch(baseURL + 'checklogin', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: recordBody
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error deleting the meta:', error);
    }
};
